module.exports = __webpack_public_path__ + "common/loading-novelty-867587e18f84b32e08365e7c2263c400.svg";